
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/events/champions-mastermind-program",
      function () {
        return require("private-next-pages/events/champions-mastermind-program/index.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/events/champions-mastermind-program"])
      });
    }
  